var createStylesheet = (chunkId, fullhref, resolve, reject) => {
	var linkTag = document.createElement("link");

	linkTag.rel = "stylesheet";
	linkTag.type = "text/css";
	var onLinkComplete = (event) => {
		// avoid mem leaks.
		linkTag.onerror = linkTag.onload = null;
		if (event.type === 'load') {
			resolve();
		} else {
			var errorType = event && (event.type === 'load' ? 'missing' : event.type);
			var realHref = event && event.target && event.target.href || fullhref;
			var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
			err.code = "CSS_CHUNK_LOAD_FAILED";
			err.type = errorType;
			err.request = realHref;
			linkTag.parentNode.removeChild(linkTag)
			reject(err);
		}
	}
	linkTag.onerror = linkTag.onload = onLinkComplete;
	linkTag.href = fullhref;

	document.head.appendChild(linkTag);
	return linkTag;
};
var findStylesheet = (href, fullhref) => {
	var existingLinkTags = document.getElementsByTagName("link");
	for(var i = 0; i < existingLinkTags.length; i++) {
		var tag = existingLinkTags[i];
		var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
		if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return tag;
	}
	var existingStyleTags = document.getElementsByTagName("style");
	for(var i = 0; i < existingStyleTags.length; i++) {
		var tag = existingStyleTags[i];
		var dataHref = tag.getAttribute("data-href");
		if(dataHref === href || dataHref === fullhref) return tag;
	}
};
var loadStylesheet = (chunkId) => {
	return new Promise((resolve, reject) => {
		var href = __webpack_require__.miniCssF(chunkId);
		var fullhref = __webpack_require__.p + href;
		if(findStylesheet(href, fullhref)) return resolve();
		createStylesheet(chunkId, fullhref, resolve, reject);
	});
}
// object to store loaded CSS chunks
var installedCssChunks = {
	"main": 0
};

__webpack_require__.f.miniCss = (chunkId, promises) => {
	var cssChunks = {"pages_index_ts":1,"pages_signup_ts":1,"vendors-node_modules_fullcalendar_core_locales_fr_js-node_modules_fullcalendar_core_main_js-n-76a744":1,"modelRepositories_EstablishmentLabelRepository_ts-pages_parameters_eventSchedule_ts-assets_cs-a648ff":1,"modelRepositories_CategoryRepository_ts-pages_products_events_events_ts-node_modules_toastr_b-f8e55c":1,"pages_products_events_event_html-controller_EventView_ts-node_modules_toastr_build_toastr_css-99b990":1,"vendors-node_modules_gaia-sdk-js_lib_src_class_Order_CashStatement_js-node_modules_luckysheet-3be6a4":1,"pages_products_bars_ts":1,"node_modules_horizon-js-front-sdk_lib_Utils_js-controller_Components_OrderComponents_ts-contr-3c35df":1,"pages_parameters_customers_ts":1,"node_modules_horizon-js-sdk_lib_Maths_js-pages_order_orders_ts-assets_css_orderImport_css":1,"pages_delivery_delivery-event_ts":1,"node_modules_horizon-js-sdk_lib_UrlParamsManager_js-pages_parameters_index_ts-assets_css_cust-60e6d9":1,"node_modules_horizon-js-front-sdk_lib_Utils_js-pages_admin_index_ts-assets_css_customModal_cs-7cc941":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = loadStylesheet(chunkId).then(() => {
			installedCssChunks[chunkId] = 0;
		}, (e) => {
			delete installedCssChunks[chunkId];
			throw e;
		}));
	}
};

// no hmr